import { zodValidator, type TypedFetch } from "@spiriidk/utils";

import { OperatorsResponseSchema } from "../../schemas/operator";

const getOperators = async (fetch: TypedFetch, signal?: AbortSignal) =>
  fetch.get("/enums/?operator=1", {
    validateResponse: zodValidator(OperatorsResponseSchema),
    signal,
  });

export { getOperators };
